import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { checkManageSubscriptionPermission } from '@ui/guards/route-checks';
export const Route = createFileRoute('/org/$organization/settings/subscription')({
    beforeLoad: async (param)=>{
        let { params, context: { queryClient } } = param;
        const can = await checkManageSubscriptionPermission(queryClient, params.organization);
        if (!can) {
            throw redirect({
                to: '/403',
                search: {
                    from: '/org/$organization/settings/subscription'
                }
            });
        }
    },
    component: RouteComponent
});
function RouteComponent() {
    return /*#__PURE__*/ _jsx(Outlet, {});
}
